import styled from 'styled-components';

import { colors, FONT_FAMILIES } from 'common/styles/style-constants';

export const Language = styled.div`
  padding: 0.5em 1.5em;
  margin: 0.25em 0.5em;

  font-family: ${FONT_FAMILIES.openSans};
  color: ${colors.white};
  text-align: center;

  background-color: ${colors.mintDark};
  border-radius: 25px;
  display: inline-block;
`;
